import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top
        window.scrollTo(0, 0);

        // Clear any scroll locks from Bootstrap offcanvas/modals
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
        document.body.classList.remove('offcanvas-backdrop', 'modal-open');
        document.body.style.height = 'auto';
        document.documentElement.style.height = 'auto';
    }, [pathname]);

    return null;
}

export default ScrollToTop;